export enum BasketballFourPointShotMadeAttribute {
  JumpShot = 858,
}
